/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Track_IntensityInputs */

const en_ui_track_intensity = /** @type {(inputs: Ui_Track_IntensityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intensity`)
};

const de_ui_track_intensity = /** @type {(inputs: Ui_Track_IntensityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intensität`)
};

/**
* | output |
* | --- |
* | "Intensity" |
*
* @param {Ui_Track_IntensityInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_track_intensity = /** @type {((inputs?: Ui_Track_IntensityInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Track_IntensityInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_track_intensity(inputs)
	return de_ui_track_intensity(inputs)
});